const heroImage = document.querySelector('.hero__image');
const starryNight = document.querySelector('.hero__starry-night');
const isMobile = window.matchMedia('(max-width: 30rem)');

if (heroImage || starryNight) {
	window.addEventListener('scroll', () => {
		// Disable parallax on mobile screens.
		if (isMobile.matches) {
			return;
		}

		const scrollY = window.scrollY;
		if (heroImage) {
			heroImage.style.translate = `0 ${scrollY * 0.3}px`;
		}
		if (starryNight) {
			starryNight.style.translate = `0 ${scrollY * 0.5}px`;
		}
	}, { passive: true });
}
